import type { IntlShape } from 'react-intl';

import { THRESHOLD } from '../../../messages.js';

export const getThresholdIntValue = (intl: IntlShape, values?: Array<string>) =>
  values
    ? values.map((value) => {
        return value === THRESHOLD.dynamic.defaultMessage
          ? intl.formatMessage(THRESHOLD.dynamic)
          : value;
      })
    : undefined;
